import React, { useEffect, useRef, useState } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import { connect } from 'react-redux';
import historyHandler from 'jd-library/historyHandler';
import styles from './msg_comp.scss';
import CSSTransition  from '../../common/transition/Animation';

const MsgComp = props => {
    let {jdEmpPresent,onHidden} = props;
    let userData = props.session.user.loginData;
    let ownerMobPresent = userData ? userData.ownerMobileList.length : 0;
    let ownerEmailPresent = userData ? userData.ownerEmailList.length : 0;
    let empName, empMob, empEmail;
    if(jdEmpPresent){
        empName = userData.employeeName;
        empMob = userData.employeeMobileList[0];
        empEmail = userData.employeeEmailList[0];
    }
    let temp = 'Please get in touch with '+(jdEmpPresent ? 'the following' : 'a')+' Justdial representative to get the mobile number added to your account if you want to authenticate from your mobile number before you can make any changes in your product catalogue.';
    let msg = '';
    if(ownerMobPresent){
        msg = temp;
    }else if(!ownerMobPresent && !ownerEmailPresent){
        msg = 'There is no mobile number or email associated with your account on Justdial. '+temp;
    }else if(!ownerMobPresent){
        msg = 'There is no mobile number associated with your account on Justdial. '+temp;
    }
    let msgBlock = (
        <div className={styles['msg-block']}>
            <div className={styles['msg-container']}>{msg}</div>
            {jdEmpPresent && <div className={styles['emp-details']}>
                <div className={styles['heading']}>Contact Details</div>
                {empName && <div className={styles['details']}>
                    <div className='icon-profile detail-icon'></div>
                    <div>{empName}</div>
                </div>}
                {empMob && <div className={styles['details']}>
                    <div className='icon-HDRcall detail-icon'></div>
                    <div>{'+91 '+empMob}</div>
                </div>}
                {empEmail && <div className={styles['details']}>
                    <div className='icon-mailLg detail-icon'></div>
                    <div>{empEmail}</div>
                </div>}
            </div>}
        </div>
    );
	return (
        ownerMobPresent && props.isMobile ? 
		<SliderWrapper
            slider={
                {className: 'message-page-b2b'}
            }
            header={{
                heading: 'Mobile No. Not Present',
                leftIcons: [{
                    className: 'icon-hdrBackNew',
                    onClick: e => {historyHandler.closeCurrent();}
                }],
                rightIcons: [],
                variant: 'secondary'
            }}
            onHidden={show => {
                onHidden();
            }}
        >
            {msgBlock}
        </SliderWrapper>
        :
        <CSSTransition>
        <div className={styles['message-page-b2b']}>
            {ownerMobPresent && !props.isMobile ? (
                <div className="msg-title">
                    Mobile No. Not Present
                </div>
            ) : null}
              {msgBlock}
            
        </div>
        </CSSTransition>
	);
};

const mapStateToProps = state => {
	return {
        session: state.session,
        isMobile: state.deviceData.isMobile
	};
};

export default connect(mapStateToProps)(MsgComp);
